module.exports = __webpack_public_path__ + "static/media/logo-vncss-s.e10ca6af.svg";